import React from "react";
import { Link } from "react-router-dom";
const services = [
  {
    src: "/assets/images/stock-img1.webp",
    label: "Motors & Drives",
  },
  {
    src: "/assets/images/stock-img2.webp",
    label: "Control Boards",
  },
  {
    src: "/assets/images/stock-img3.webp",
    label: "Door & <br> Seals",
    extraClass: "white",
  },
  {
    src: "/assets/images/stock-img4.webp",
    label: "Valves & <br> Pumps",
  },
  {
    src: "/assets/images/stock-img5.webp",
    label: "Heating Elements",
  },
  {
    src: "/assets/images/stock-img6.webp",
    label: "Suspension & Shock",
  },
  {
    src: "/assets/images/stock-img7.webp",
    label: "Belts & <br> Pulley",
  },
  {
    src: "/assets/images/stock-img8.webp",
    label: " Dispensers & Trays",
  },
  {
    src: "/assets/images/stock-img9.webp",
    label: "Filters & Hoses",
  },
  {
    src: "/assets/images/stock-img10.webp",
    label: "Bearings & Seals",
  },
  {
    src: "/assets/images/stock-img11.webp",
    label: "Drum Components",
  },


  {
    src: "/assets/images/stock-img12.webp",
    label: "Electrical Components",
  },
];

const LogisticsStock = () => {
  return (
    <section className="offered-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-12 col-lg-5">
            <div className="offered-content">
              <h4 className="heading">Stocked Right, Checked Twice, Shipped Fast </h4>
              <p>
               Supershine carries a wide inventory of genuine and performance-matched equipment for every major industrial laundry equipment brand. When a breakdown hits, your equipment is already warehoused, verified to match your machine's exact needs, and on its way before downtime starts eating into your schedule.
              </p>
              <div className="offer-btn">
                <Link className="default-btn" to="/contact"><span>Request Equipment  Quote</span></Link>
              </div>
            </div>
          </div>

          {/* Right Grid */}
          <div className="col-md-12 col-lg-7">
            <div className="grid-container">
              {services.map((item, index) => (
                <div key={index} className="grid-item"   >
                  <div className={`circle-icon ${item.extraClass || ""}`}>
                    <img src={item.src} className="img-responsive" alt="Equipment" />
                  </div>
                  <div className="label" dangerouslySetInnerHTML={{ __html: item.label }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticsStock;





